export const DEFAULT_SENTRY_DSN = 'https://b4809697c8414e498953f7bce4fb133a@sentry.io/252874';

const
    PRODUCTION_HOST = 'www.ultradent.com',
    STAGING_HOST = 'stage.ultradent.com';

function parseEnabledOverride ( value ) {
    if ( value === true || value === 1 || value === '1' || value === 'true' ) {
        return true;
    }
    if ( value === false || value === 0 || value === '0' || value === 'false' ) {
        return false;
    }
    return null;
}

export function getLoggingConfig ( options = {} ) {
    const hostname = options.hostname || '';
    const enabledOverride = parseEnabledOverride( options.enabledOverride );
    const isStorefrontHost = hostname === PRODUCTION_HOST || hostname === STAGING_HOST;
    const enabledByHost = options.nodeEnv === 'production' && isStorefrontHost;
    const environment = hostname === PRODUCTION_HOST ? 'Production Frontend' :
        hostname === STAGING_HOST ? 'Staging Frontend' : options.loggingEnv || 'Development Frontend';

    return {
        dsn: options.dsn || DEFAULT_SENTRY_DSN,
        enabled: enabledOverride === null ? enabledByHost : enabledOverride,
        environment
    };
}
